module.exports = __webpack_public_path__ + "static/facepalm-10fc27518e096dc4e60921fcb49d9c54.png";